<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (currentCustomer) {
  <div class="row mb-4 mb-lg-0">
    <div class="col-lg-12">
      <div class="tile customer">
        <div class="section">
          <div class="customer-header">
            <div class="d-flex align-items-center">
              {{ 'depot-header.depot' | transloco }}
              @if ((customerStateFacade.customerBaseData$ | async)?.hasActiveWallet) {
                <span class="ml-1">+ Wallet</span>
              }
              <web-design-system-icon
                name="line-chart"
                size="small"
                color="action"
                class="ml-2 cursor-pointer"
                (click)="navigateToStatistics()"
              />
            </div>
          </div>
          @if (isPerformanceReady) {
            <div class="customer-value opacity-container" [class.active]="performance">
              <span class="current-value" data-zid="depot-value">{{ performance?.currentValue | number: '1.2-2' }}<sub>€</sub></span>
            </div>
          } @else {
            <div class="loading-shimmer performance-header-value"></div>
          }
        </div>
        <div class="spacer remove"></div>
        <div class="section custom-section performance">
          <div class="customer-header">
            <a class="link-secondary text-default cursor-pointer d-flex align-items-center no-select" (click)="toggleTypeOfPerformance()">
              {{ (isPerformanceToday ? 'depot-header.perf-today' : 'depot-header.perf-all') | transloco }}
              <svg class="icon icon-16 ml-2 cursor-pointer">
                <use xlink:href="/assets/img/svgs/svgset.svg#refreshIcon" />
              </svg>
            </a>
          </div>
          @if (isPerformanceReady) {
            <div class="customer-value">
              @if (isPerformanceToday) {
                <div
                  class="text-right quoteindicator-variant2"
                  zeroBlink
                  [class.text-color-success]="performance?.perfTodayPct >= 0"
                  [class.text-color-error]="performance?.perfTodayPct < 0"
                  [val]="performance?.perfTodayPct"
                >
                  @if (performance?.perfTodayPct > 0) {
                    +
                  }
                  {{ performance?.perfTodayPct | number: '1.2-2' }}<sub>%</sub>
                </div>
                <div [class.text-color-success]="performance?.perfTodayAbs >= 0" [class.text-color-error]="performance?.perfTodayAbs < 0">
                  @if (performance?.perfTodayAbs > 0) {
                    +
                  }
                  {{ performance?.perfTodayAbs | number: '1.2-2' }}<sub>€</sub>
                </div>
              }
              @if (!isPerformanceToday) {
                <div
                  class="text-right quoteindicator-variant2"
                  zeroBlink
                  [val]="performance?.sumPerfPct"
                  [class.text-color-success]="performance?.sumPerfPct >= 0"
                  [class.text-color-error]="performance?.sumPerfPct < 0"
                >
                  @if (performance?.sumPerfPct > 0) {
                    +
                  }
                  {{ performance?.sumPerfPct | number: '1.2-2' }}<sub>%</sub>
                </div>
                <div [class.text-color-success]="performance?.sumPerfAbs >= 0" [class.text-color-error]="performance?.sumPerfAbs < 0">
                  @if (performance?.sumPerfAbs > 0) {
                    +
                  }
                  {{ performance?.sumPerfAbs | number: '1.2-2' }}<sub>€</sub>
                </div>
              }
            </div>
          } @else {
            <div class="loading-shimmer performance-header-perf"></div>
          }
        </div>
        <div class="spacer"></div>
        @if (customerStateFacade.customerAccountData$ | async; as customerAccount) {
          <div class="section">
            <div class="customer-header">
              <a [routerLink]="commonRoutes.postlogin.accountoverview" class="link-secondary text-default mr-2">{{
                'depot-header.account' | transloco
              }}</a>
              <span class="mr-1">IBAN</span>
              <web-design-system-copy-to-clipboard
                [showLabel]="false"
                [label]="dataService.spacify(customerAccount.accountIban)"
                iconCssClass="icon-secondary"
                labelCssClass="text-size-small"
                [hint]="'mydepot.deposit.copy-iban' | transloco"
              />
            </div>
            <div class="customer-value single">
              @if (isPerformanceReady && (customerAccount.intradayAmount || customerAccount.intradayAmount === 0)) {
                {{ customerAccount.intradayAmount | number: '1.2-2' }}<sub>€</sub>
              } @else if (!performance || !(customerAccount.intradayAmount || customerAccount.intradayAmount === 0)) {
                -,--- <sub>€</sub>
              } @else {
                <div class="loading-shimmer performance-header-perf"></div>
              }
            </div>
          </div>
          <div class="spacer remove"></div>
          <div class="section custom-section">
            <div class="customer-header">
              {{ 'depot-header.all' | transloco }}
            </div>
            <div class="customer-value single">
              @if (isPerformanceReady && performance && (customerAccount.intradayAmount || customerAccount.intradayAmount === 0)) {
                {{ customerAccount.intradayAmount + performance?.currentValue | number: '1.2-2' }}<sub>€</sub>
              } @else if (!performance || !(customerAccount.intradayAmount || customerAccount.intradayAmount === 0)) {
                -,--- <sub>€</sub>
              } @else {
                <div class="loading-shimmer performance-header-perf"></div>
              }
            </div>
          </div>
        }
        @if (customerStateFacade.customerBaseData$ | async; as customerBaseData) {
          @if (customerBaseData.lombardEnabled) {
            @if (lombardFacade.lombard$ | async; as lombard) {
              <div class="spacer"></div>
              <div class="section">
                <div class="customer-header">
                  @if (lombard.lombardDataStatus === 'INITIAL') {
                    <a [routerLink]="commonRoutes.postlogin.lombard" class="link-secondary text-default">
                      {{ 'depot-header.lombard.initial' | transloco }}
                    </a>
                  } @else {
                    @if (!lombard.currentUsedCreditAmount) {
                      <a [routerLink]="commonRoutes.postlogin.lombard" class="link-secondary text-default">
                        {{ 'depot-header.lombard.credit' | transloco }}
                      </a>
                    }
                    @if (lombard.currentUsedCreditAmount) {
                      <div class="d-flex align-items-center" [ngClass]="lombard.lombardWarninglevel">
                        <a [routerLink]="commonRoutes.postlogin.lombard" class="link-secondary text-default">
                          {{ 'depot-header.lombard.used' | transloco }}
                        </a>
                        @if (lombard.lombardWarninglevel === 'FATAL') {
                          <svg class="icon icon-16 cursor-pointer ml-1" (click)="modal.open(warningLevelModal)">
                            <use xlink:href="/assets/img/svgs/svgset.svg#info-23" />
                          </svg>
                          <ng-template #warningLevelModal let-modal>
                            <web-design-system-modal (dismiss)="modal.dismiss('Cross click')">
                              <p>{{ 'lombard.warning-level.' + lombard.lombardWarninglevel | transloco }}</p>
                            </web-design-system-modal>
                          </ng-template>
                        }
                      </div>
                    }
                  }
                </div>
                <div class="customer-value single">
                  @if (lombard.lombardDataStatus === 'INITIAL') {
                    <span data-zid="max-credit-amount">{{ lombard.maxCreditAmount | number: '1.0-0' }}<sub>€</sub></span>
                  } @else {
                    @if (!lombard.currentUsedCreditAmount) {
                      <span data-zid="current-credit-amount">{{ lombard.currentCreditAmount | number: '1.0-0' }}<sub>€</sub></span>
                    }
                    @if (lombard.currentUsedCreditAmount) {
                      <span data-zid="current-used-credit-amount">{{ lombard.currentUsedCreditAmount | number: '1.2-2' }}<sub>€</sub></span>
                    }
                  }
                </div>
              </div>
            }
          }
        }
        <div class="spacer d-none d-xl-block"></div>
        <div class="buttons-container">
          <web-design-system-button
            size="small"
            [fullwidth]="true"
            class="mb-2"
            data-zid="depot-header-deposit-button"
            (click)="navigateToDeposit()"
          >
            {{ 'depot-header.buttons.deposit' | transloco }}
          </web-design-system-button>
          <div class="row">
            <div class="col pr-1">
              <web-design-system-button
                class="button-holder"
                size="small"
                [fullwidth]="true"
                (click)="navigateToOrderMask()"
                data-zid="depot-header-buy-button"
              >
                {{ 'depot-header.buttons.order' | transloco }}
              </web-design-system-button>
            </div>
            <div class="col pl-1">
              <web-design-system-button
                size="small"
                class="button-holder"
                [fullwidth]="true"
                (click)="navigateToMultiOrderMask()"
                data-zid="depot-header-multi-order-button"
              >
                {{ 'depot-header.buttons.multi-order' | transloco }}
              </web-design-system-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (isPotentialCustomer) {
  <div class="pt-3 pb-3 mb-4">
    @if (!alreadyCustomer && !openingStarted) {
      <div class="d-flex justify-content-center mb-4">
        <web-design-system-button [routerLink]="commonRoutes.postlogin.onboarding.redirect">
          {{ 'depot-header.potential-customer.onboarding' | transloco }}
        </web-design-system-button>
      </div>
    }
    @if (!alreadyCustomer && openingStarted) {
      <p class="text-center">{{ 'depot-header.potential-customer.opening-started.hint' | transloco }}</p>
      <div class="d-flex justify-content-center mb-4">
        <web-design-system-button [routerLink]="commonRoutes.postlogin.onboarding.redirect">
          {{ 'depot-header.potential-customer.opening-started.button' | transloco }}
        </web-design-system-button>
      </div>
    }
    @if (alreadyCustomer) {
      <p class="text-center">{{ 'depot-header.potential-customer.already-customer' | transloco }}</p>
    }
  </div>
}
